

import React from 'react'
import { Get, wrapResponse } from './../../../requst'
require('./about.scss')
require('./mobile_about.scss')


export default class About extends React.Component {
    static async getInitialProps(ctx) {
        const data = await wrapResponse(Get({ url: 'base/about' }))
        return { data }
    }

    constructor(props, context) {
        super(props, context)
        this.state = {

        }

    }

    componentDidMount() {
        !function (e) {
            function t(a) { if (i[a]) return i[a].exports; var n = i[a] = { exports: {}, id: a, loaded: !1 }; return e[a].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports } var i = {};
            return t.m = e, t.c = i, t.p = "", t(0)
        }([function (e, t) {
            "use strict"; Object.defineProperty(t, "__esModule", { value: !0 });
            var i = window;
            t["default"] = i.flex = function (normal, e, t) {
                var a = e || 100, n = t || 1, r = i.document, o = navigator.userAgent, d = o.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i), l = o.match(/U3\/((\d+|\.){5,})/i), c = l && parseInt(l[1].split(".").join(""), 10) >= 80, p = navigator.appVersion.match(/(iphone|ipad|ipod)/gi), s = i.devicePixelRatio || 1;
                p || d && d[1] > 534 || c || (s = 1); var u = normal ? 1 : 1 / s, m = r.querySelector('meta[name="viewport"]'); m || (m = r.createElement("meta"), m.setAttribute("name", "viewport"), r.head.appendChild(m)), m.setAttribute("content", "width=device-width,user-scalable=no,initial-scale=" + u + ",maximum-scale=" + u + ",minimum-scale=" + u), r.documentElement.style.fontSize = normal ? "50px" : a / 2 * s * n + "px"
            }, e.exports = t["default"]
        }]); flex(false, 100, 1);

        this.setState({ offsetWidth: document.body.offsetWidth })
    }
    render() {
        // console.log(document.body.offsetWidth)
        if (this.state.offsetWidth >= 1200) {
            return (

                <div className="AboutContainer">
                    <div className="AboutTitle">
                        <p>关于我们</p>
                        <p>About Us</p>
                        <img src={require('../../../assets/common/images/biaotizhuangshi-bai.png')} alt="" />
                    </div>
                    <ul className="AboutContent">
                        <li className="AboutImg">
                            <img src={require('../../../assets/common/images/guanyuwomen.png')} alt="" />
                        </li>
                        <li className="AboutText">
                            <p>{this.props.data ? this.props.data.profiles : null}</p>
                            <a href="/aboutus">
                                详情
                        </a>
                        </li>
                    </ul>
                </div>
            )
        } else {
            return (
                <div className="Mobile_About">
                    <p className="Mobile_Title">关于我们</p>
                    <p className="Mobile_SubTitle">AboutUs</p>
                    <img src={require('../../../assets/common/images/biaotizhuangshi2@3x.png')} alt="" />
                    <div className="Mobile_ContentBox">
                        <div className="Image fl"><img src={require('../../../assets/common/images/guanyuwomen@3x.png')} alt="" /></div>
                        <p className="Text fl">四川泛梦科技有限公司是西南领先的软件与解决方案提供商。以成熟的智慧、工程师的精神，为客户提供优质的服务与产品。</p>
                        <button className="fl"></button>
                    </div>
                </div>
            )
        }

    }
}